import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { USER_GROUPS } from 'utils/Constants';
import { getUserGroups } from '../../utils/Session';

const AdminRoute = () => {
    const [isAbleToAccess, setIsAbleToAccess] = useState();
    useEffect(() => {
        getUserGroups().then(userGroup => {
            setIsAbleToAccess( userGroup.includes(USER_GROUPS.ADMIN)|| false);
        }).catch(e => setIsAbleToAccess(false));
    }, []);

    return isAbleToAccess === undefined ? null : isAbleToAccess ? <Outlet /> : <Navigate to="/auth/login" />;

};

export default AdminRoute;